module.exports = __webpack_public_path__ + "static/media/detail_0010_t.f8b9caae.jpg";